export const toPercent = (number: number) =>
  number.toLocaleString('pl-PL', { style: 'percent', maximumFractionDigits: 4 });
